var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44C48.4183 0 52 3.58172 52 8V52H0V0Z",
    fill: "#0e0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 19.75C23.5047 19.75 21.8 21.4322 21.8 23.5C21.8 25.5678 23.5047 27.25 25.6 27.25C27.6953 27.25 29.4 25.5678 29.4 23.5C29.4 21.4322 27.6953 19.75 25.6 19.75ZM25.6 26C24.2031 26 23.0667 24.8785 23.0667 23.5C23.0667 22.1215 24.2031 21 25.6 21C26.9969 21 28.1333 22.1215 28.1333 23.5C28.1333 24.8785 26.9969 26 25.6 26ZM25.6 16C21.4026 16 18 19.3579 18 23.5C18 26.5239 19.0676 27.3684 24.8189 35.5965C25.1963 36.1345 26.0036 36.1345 26.3811 35.5965C32.1324 27.3684 33.2 26.5239 33.2 23.5C33.2 19.3579 29.7974 16 25.6 16ZM25.6 34.5129C20.0862 26.6441 19.2667 26.0193 19.2667 23.5C19.2667 21.8305 19.9255 20.2611 21.1217 19.0806C22.3179 17.9001 23.9083 17.25 25.6 17.25C27.2917 17.25 28.8821 17.9001 30.0783 19.0806C31.2745 20.2611 31.9333 21.8305 31.9333 23.5C31.9333 26.0191 31.1143 26.6434 25.6 34.5129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMap);
export default __webpack_public_path__ + "static/media/address-map.0fc04ea3c159e10853d9daec50f13d91.svg";
export { ForwardRef as ReactComponent };